import {
  Component, OnInit, AfterViewInit, OnDestroy,
  signal, inject, ChangeDetectionStrategy,
} from '@angular/core';
import { FormsModule } from '@angular/forms';
import { RouterLink } from '@angular/router';
import { CrmLeadService } from '../../services/crm-lead.service';
import { Auth } from '@angular/fire/auth';
import { toSignal } from '@angular/core/rxjs-interop';
import { user } from '@angular/fire/auth';

@Component({
  selector: 'app-proximamente',
  standalone: true,
  imports: [FormsModule, RouterLink],
  templateUrl: './proximamente.component.html',
  styleUrls: ['./proximamente.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ProximamenteComponent implements OnInit, AfterViewInit, OnDestroy {
  private readonly crmLeadService = inject(CrmLeadService);
  private readonly auth = inject(Auth);

  readonly currentUser = toSignal(user(this.auth));

  // Hero form — regular properties for ngModel two-way binding
  heroEmail   = '';
  heroConsent = false;
  readonly heroLoading = signal(false);
  readonly heroSuccess = signal(false);
  readonly heroError   = signal<string | null>(null);

  // CTA final form
  ctaEmail   = '';
  ctaConsent = false;
  readonly ctaLoading = signal(false);
  readonly ctaSuccess = signal(false);
  readonly ctaError   = signal<string | null>(null);

  // Tabs
  readonly activeTab = signal<'owners' | 'renters'>('owners');

  // Privacy modal
  readonly showPrivacy = signal(false);

  // Cookie banner
  readonly showCookie = signal(false);

  private observers: IntersectionObserver[] = [];

  ngOnInit(): void {
    if (typeof localStorage !== 'undefined' && !localStorage.getItem('tfr_cookie_ok')) {
      this.showCookie.set(true);
    }
  }

  ngAfterViewInit(): void {
    const targets = document.querySelectorAll<HTMLElement>('.reveal');
    const obs = new IntersectionObserver(entries => {
      entries.forEach(e => { if (e.isIntersecting) e.target.classList.add('visible'); });
    }, { threshold: 0.12 });
    targets.forEach(t => obs.observe(t));
    this.observers.push(obs);
  }

  ngOnDestroy(): void {
    this.observers.forEach(o => o.disconnect());
  }

  async submitHero(): Promise<void> {
    if (!this.heroConsent || !this.heroEmail) return;
    this.heroLoading.set(true);
    this.heroError.set(null);
    try {
      await this.crmLeadService.createLeadFromLanding(this.heroEmail);
      this.heroSuccess.set(true);
    } catch {
      this.heroError.set('Error al guardar. Inténtalo de nuevo.');
    } finally {
      this.heroLoading.set(false);
    }
  }

  async submitCta(): Promise<void> {
    if (!this.ctaConsent || !this.ctaEmail) return;
    this.ctaLoading.set(true);
    this.ctaError.set(null);
    try {
      await this.crmLeadService.createLeadFromLanding(this.ctaEmail);
      this.ctaSuccess.set(true);
    } catch {
      this.ctaError.set('Error al guardar. Inténtalo de nuevo.');
    } finally {
      this.ctaLoading.set(false);
    }
  }

  acceptCookies(): void {
    if (typeof localStorage !== 'undefined') localStorage.setItem('tfr_cookie_ok', '1');
    this.showCookie.set(false);
  }

  rejectCookies(): void {
    this.showCookie.set(false);
  }
}
